import { render } from "./App.vue?vue&type=template&id=9cd6a344"
const script = {}

import "./App.vue?vue&type=style&index=0&id=9cd6a344&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__